"use client";

import React, { useEffect, useRef, useState } from "react";
import style from "./Join.module.scss";
import Wave from "react-wavify";
import { MagneticChipButton } from "@/components/common/Buttons/MagneticChipButton/MagneticChipButton";
import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";
import Scene from "@/components/common/3D/Scene";
import Duck from "@/components/common/3D/Duck";
import { PerspectiveCamera } from "@react-three/drei";
import { degToRad } from "three/src/math/MathUtils";
import { AnimationStateKeys, useDuck } from "@/provider/DuckContext";
import FollowWave from "@/components/common/3D/FollowWave";
import { useDeviceDetector } from "@/utils/useDeviceDetector";

export const Join = ({ messages }) => {
  const [amplitude, setAmplitude] = useState(60);

  const { isMobile } = useDeviceDetector();

  useEffect(() => {
    setAmplitude(isMobile ? 25 : 60);
  }, [isMobile]);

  const { handleDuckAnimation } = useDuck();

  const waveRef = useRef(null);

  return (
    <section className={style.sectionContainer}>
      <div className="container">
        <div
          className={style.textContainer}
          onMouseEnter={() => handleDuckAnimation(AnimationStateKeys.YES)}
        >
          <TitleAnimation
            messages={{
              first_word: messages.first_words,
              second_word: messages.second_words,
              third_word: messages.last_word,
            }}
            lastWords={style.lastWords}
          />
          <p className={style.description}>{messages?.description}</p>
          <MagneticChipButton
            label={messages.button}
            variant="outline-white"
            onClick={() => null}
            href={`/trabaja-con-nosotros`}
          />
        </div>
      </div>
      <div
        className={style.wave}
        style={{
          display: "flex",
          transform: "rotate(180deg)",
          height: "100%",
          width: "100%",
          position: "absolute",
          left: 0,
          top: 0,
          zIndex: 1,
        }}
        ref={waveRef}
      >
        <Wave
          fill="var(--primary)"
          paused={false}
          options={{
            height: 50,
            amplitude: amplitude,
            speed: 0.15,
            points: 2,
          }}
        />
      </div>
      <Scene
        className={style.canvas}
        parentStyle={false}
        style={{
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      >
        <PerspectiveCamera position={[0, 0, 10]} fov={30} makeDefault />
        <FollowWave
          wave={waveRef.current?.lastChild}
          inverse
          positionOffset={-1.25}
          positionForce={140}
          speedFactor={1.75}
        >
          <Duck
            position={isMobile ? [0, -1.4, 0] : [0, -1.6, 0]}
            rotation={[0, degToRad(-45), 0]}
            scale={isMobile ? 3 : 4}
            cursorAnimations
            cursorAngleLimit={15}
          />
        </FollowWave>
      </Scene>
    </section>
  );
};
